
// tracking.js

export function initTracking() {
    // context handling was PHP injected in header, we might need to pass it differently
    // or assume it's set globally if needed.
    // In header.php it echoed into a global var 'context'.
    // If tracking.js is imported in bundle, it runs after bundle loaded.

    if (navigator.userAgent.includes('wv') || navigator.userAgent.includes('WebView')) {
        document.documentElement.classList.add('webview');
    }

    // Función para obtener parámetros de la URL
    function getParameterByName(name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // Obtener el valor de 'utm_source' de la URL
    var utmSource = getParameterByName('utm_source');

    // Determinar el código de afiliado basado en 'utm_source'
    var affiliate_code = '';
    if (utmSource === 'google') {
        affiliate_code = 'google_ads';
    } else if (utmSource === 'facebook' || utmSource === 'instagram') {
        affiliate_code = 'facebook_ads';
    }

    // Si se encuentra un código de afiliado, guardar en una cookie
    if (affiliate_code) {
        document.cookie = "affiliate=" + affiliate_code + "; path=/; domain=.facturavia.com; max-age=2592000"; // La cookie es válida durante 1 día
    }

    // Obtiene el gclid de la URL
    var gclid = getParameterByName('gclid');
    if (gclid) {
        // Si hay un gclid, guárdalo en una cookie por 30 días
        document.cookie = "gclid=" + gclid + "; path=/; domain=.facturavia.com; max-age=2592000";
    }

    // Obtiene el utm_campaign de la URL
    var utm_campaign = getParameterByName('utm_campaign');
    if (utm_campaign) {
        // Si hay un gclid, guárdalo en una cookie por 30 días
        document.cookie = "utm_campaign=" + utm_campaign + "; path=/; domain=.facturavia.com; max-age=2592000";
    }

    // Obtiene el utm_source de la URL
    var utm_source = getParameterByName('utm_source');
    if (utm_source) {
        // Si hay un gclid, guárdalo en una cookie por 30 días
        document.cookie = "utm_source=" + utm_source + "; path=/; domain=.facturavia.com; max-age=2592000";
    }
}
